import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
// Custom CSS for Tidio positioning
import './tidio-positioning.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider,useUserContext } from "./lib/user_context";

import ReHelmet from "./Helmet";

// Create a TidioLoader component to handle script loading and CSS injection
const TidioLoader = () => {
  const { sessionShowChat } = useUserContext();

  useEffect(() => {
    // Load the Tidio script if it's not already there
    if (!document.querySelector('script[src="//code.tidio.co/c9qnm0vk1h183dspvaeg2nir0zq8ixfh.js"]')) {
      const script = document.createElement('script');
      script.src = "//code.tidio.co/c9qnm0vk1h183dspvaeg2nir0zq8ixfh.js";
      script.async = true;
      document.body.appendChild(script);
    }

    const updateTidioVisibility = () => {
      if (sessionShowChat) {
        document.body.classList.remove('hide-tidio-chat');
        if (window.tidioChatApi) {
          window.tidioChatApi.show();
        }
      } else {
        document.body.classList.add('hide-tidio-chat');
        if (window.tidioChatApi) {
          window.tidioChatApi.hide();
        }
      }
    };

    updateTidioVisibility();

    const onTidioReady = () => {
      updateTidioVisibility();
    };

    document.addEventListener('tidioChat-ready', onTidioReady);

    return () => {
      document.removeEventListener('tidioChat-ready', onTidioReady);
    };
  }, [sessionShowChat]);

  return null;
};

const root = createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
        <ReHelmet title="Lattice Portal" />
        <UserProvider>
          <App />
          <TidioLoader />
        </UserProvider>
    </HelmetProvider>
);

reportWebVitals();